import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { NewsEventModel } from '../../../domain/entities/NewsEventModel';
import TruncatedText from '../utilsComponents/TruncateTextComponents';

interface AnotherNewsEventItemProps {
    newsEvent: NewsEventModel
}

const AnotherNewsEventItemComponents: React.FC<AnotherNewsEventItemProps> = ({newsEvent}) => {
    const navigate = useNavigate();

    const handleClickDetail = () => {
        navigate("/detailnews", { state: { newsEvent }});
    }

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    
    // Handle window resize
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        // Add event listener
        window.addEventListener('resize', handleResize);

        // Cleanup
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Get current banners based on device type
    const pathImage = isMobile ? newsEvent.path_app : newsEvent.path;

    return(
        <div className="flex flex-row w-full h-20 md:h-20 bg-white cursor-pointer items-center justify-center" onClick={handleClickDetail}>
            <img className="w-20 md:w-20 h-20 md:h-20 rounded-xl shadow-md mr-2 object-cover" src={pathImage} alt="News" />
            <TruncatedText 
                text={newsEvent.news_title} 
                maxLength={40} 
                className="text-sm md:text-base text-start text-gray-800 font-semibold font-poppins mt-1 md:mt-2" 
            />
        </div>
    );
}

export default AnotherNewsEventItemComponents;